<template>
  <div class="compressed-content">
    <h3>
      Have you had a test for LDL particle number (LDL-P)? <br />
      If yes, what was your highest score?
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadTest">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.hadTest" name="test"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.hadTest" name="test"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
    <v-form-group class="page-buttons" v-if="hadTest" :validator="$v.testScore" label="Highest score">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.bloodBiochemistry.cholesterol.testScore"
                    placeholder="300 - 3600" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, requiredIf, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hadTest: {
        required
      },
      testScore: {
        required: requiredIf(function () { return this.hadTest; }),
        between: between(300, 3600),
        numeric
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadTest() { return this.survey.bloodBiochemistry.cholesterol.hadTest; },
      testScore() { return this.survey.bloodBiochemistry.cholesterol.testScore; }
    }
  };
</script>